import {useRef} from "react";
import {createPortal} from "react-dom";

import {ICON_NAMES} from "../../../../../utilities/generalConstants.js/generalConstants";
import Icon from "../../../../Icon/Icon";

import "../../../../../Styles/Buttons.scss";

const FileInput = ({accept, addFunc = () => {}}) => {
  const fileref = useRef();

  const handleLabelClick = e => {
    e.stopPropagation();

    fileref.current.click();
  };

  const handleFileChange = e => {
    const fileList = e.target.files;
    if (!fileList || fileList.length === 0) return;

    const arrFiles = Array.from(fileList);
    addFunc(arrFiles);
    fileref.current.value = "";
  };

  return (
    <div>
      <div className="btn__upload">
        <div onClick={handleLabelClick} style={{cursor: "pointer"}}>
          <Icon name={ICON_NAMES.ADD_IMG} width={80} height={80} className="icon-upload" />
        </div>

        {createPortal(
          <input
            ref={fileref}
            type="file"
            accept={accept}
            multiple={true}
            onChange={handleFileChange}
            className="hiddenEl"
          />,
          document.body,
        )}
      </div>
    </div>
  );
};

export default FileInput;
